import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import {
    VolumeCurveElement,
    VolumeCurveTimeSeriesData,
    VolumeCurveTimeSeriesElement,
} from 'widgets/volumeCurve/api/VolumeCurveElement.ts';
import {
    initialVolumeCurveDataState,
    initialVolumeCurveStreamState,
    VolumeCurveDataState,
    VolumeCurveStreamedDataStreamState,
    VolumeCurveStreamState,
} from 'widgets/volumeCurve/store/data/VolumeCurveDataState.ts';
import {
    createByStreamKeyReducer,
    createProcessStreamByStreamKeyDataMessage,
} from 'streamsState/store/streamedData/createByStreamKeyReducer.ts';
import {
    StreamDisableRangeElement,
    StreamMessageElement,
} from 'communication/types/StreamElement.ts';
import { WidgetStreamMessagesState } from 'widgets/store/stream/WidgetStreamState.ts';
import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils.ts';
import { StreamElementType } from 'communication/types/StreamElementType.ts';
import streamMessagesReducer, {
    omitStreamMessageTypeField,
} from 'utils/messages/StreamMessage.ts';
import disableRangeReducer from 'widgets/store/disableRange/StreamDisableRangeDataState.ts';
import omitUndefined from 'utils/omitUndefined.ts';
import { mapSessionBoundary } from 'utils/timeseries/TimeSeriesDisableRange.ts';

const processVolumeCurveDataStreamElement = (
    element: VolumeCurveElement,
    nextDataState: VolumeCurveDataState,
    nextMessagesState: WidgetStreamMessagesState
) => {
    timeSeriesReducer(
        element as VolumeCurveTimeSeriesElement<StreamElementType>,
        nextDataState,
        mapToTimeSeriesItem
    );
    streamMessagesReducer(element as StreamMessageElement, nextMessagesState);
    disableRangeReducer(element as StreamDisableRangeElement, nextDataState);

    switch (element._c) {
        case StreamElementType.OrderStat: {
            nextDataState.orderStat = omitStreamMessageTypeField(element);
            break;
        }
    }
};

const processDataStreamElement = (
    element: VolumeCurveElement,
    nextState: VolumeCurveStreamedDataStreamState
) => {
    const nextDataState = nextState.data ?? { ...initialVolumeCurveDataState };
    processVolumeCurveDataStreamElement(element, nextDataState, nextState);
};

const processDataStreamMessage = createProcessStreamByStreamKeyDataMessage<
    VolumeCurveDataState,
    VolumeCurveElement,
    VolumeCurveStreamedDataStreamState
>(processDataStreamElement);

export const selectVolumeCurveStreamRequestBySymbolStreamedData = (
    state: State
) => selectStreamedDataState(state).volumeCurve;

export const volumeCurveStreamDataReducer = createByStreamKeyReducer<
    VolumeCurveDataState,
    VolumeCurveElement,
    VolumeCurveStreamState
>(
    'startVolumeCurveStream',
    initialVolumeCurveStreamState,
    processDataStreamMessage
);

export function mapToTimeSeriesItem<T>(
    from: VolumeCurveTimeSeriesElement<T>
): VolumeCurveTimeSeriesData {
    return omitUndefined({
        v: from.v,
        vp: from.vp,
        avp: from.avp,
        ...mapSessionBoundary(from),
    });
}
